import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import tennosLogo from "./Tennos-logo-w.png";
import { formatMonto } from "@/utils";

const generatePDF = (characterData, data2, donwload) => {
  const frame = document.querySelector("#frameQuote");
  const doc = new jsPDF();

  doc.setProperties({
    title: `Cotización-del-cliente-${characterData.clientName}`
  });

  const docWidth = doc.internal.pageSize.getWidth();
  const docHeight = doc.internal.pageSize.getHeight();

  var priceInst = data2.priceInstalacion * characterData.quantity;
  var subtotal = data2.priceTotal + priceInst - data2.discount;
  var itbis = (subtotal / 100) * 18;
  // var total = subtotal - data2.discount + itbis;
  var totalImporte = data2.priceTotal - data2.discount;
  var totales = subtotal - data2.discount + itbis;
  doc.setFontSize(7);
  doc.addImage(tennosLogo, "JPEG", 10, 0, 50, 50);
  doc.text("RNC: 131844804", 25, 48);

  autoTable(doc, {
    headStyles: { fillColor: "#36AEE9" },
    columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
    margin: { top: 10, left: 150 },
    head: [
      ["Cotización venta", ""],
      ["Fecha cotización", "Número"]
    ],
    body: [[data2.fechaEmi, data2.numQuote]],
    theme: "grid",
    tableWidth: 50
  });

  doc.setFontSize(10);
  doc.setFillColor("#C5C5C5");
  doc.rect(10, 55, 190, 10, "F");
  doc.setFont("Times-Roman", "bold");
  doc.text("Para ", 10, 59);
  doc.setFont("Times-Roman", "bold");
  doc.text(characterData.clientName, 60, 59);

  doc.setFontSize(12);
  doc.setFont("Times-Roman", "bold");
  doc.text("RNC", 10, 64);
  doc.setFont("Times-Roman", "bold");
  doc.text(characterData.RNC_Cedula, 60, 64);

  doc.setFontSize(12);
  doc.setFont("Times-Roman", "normal");
  doc.text("Dirección: ", 10, 70);
  doc.text(characterData.address + characterData.address2, 60, 70);

  doc.text("Teléfono: ", 10, 75);
  doc.text(characterData.phone, 60, 75);

  doc.text("Vendedor: ", 120, 75);
  doc.text(characterData.sellerName, 150, 75);

  doc.text("Condiciones de Pago: ", 10, 80);
  doc.text(data2.paymentCondition, 60, 80);

  doc.text("Contacto: ", 10, 85);
  doc.text("", 60, 85);

  doc.text("Valores en: ", 155, 85);
  doc.text(characterData.codDivisa + "$", 175, 85);

  doc.line(10, 90, docWidth - 10, 90);

  doc.setFontSize(12);
  doc.setFont("Times-Roman", "bold");
  doc.text("Descripción", 10, 95);
  doc.text("Servicio " + characterData.productName.toString(), 10, 105);
  doc.text("Precio de instalación", 10, 110);

  doc.text("Cant. ", 110, 95);
  doc.text(characterData.quantity.toString(), 110, 105);
  doc.text(characterData.quantity.toString(), 110, 110);

  doc.text("% Desc. ", 130, 95);
  doc.text(formatMonto(data2.discount.toString()), 130, 105);

  doc.text("P/U ", 150, 95);
  doc.text(formatMonto(characterData.unitPrice.toString()), 150, 105);
  doc.text(formatMonto(data2.priceInstalacion.toString()), 150, 110);

  doc.text("Importe ", 170, 95);
  doc.text(formatMonto(totalImporte), 170, 105);
  doc.text(formatMonto(priceInst), 170, 110);

  doc.line(10, 100, docWidth - 10, 100);

  doc.setFont("helvetica", "bold");
  doc.text("******* Última Línea *******", 70, 130);

  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  doc.text("Importe sujeto a impuestos", 10, docHeight - 70);
  doc.text("" + formatMonto(subtotal), 60, docHeight - 70);
  doc.text("Importe exento de impuestos ", 10, docHeight - 65);
  doc.text("0.00", 60, docHeight - 65);

  autoTable(doc, {
    headStyles: { fillColor: "#36AEE9" },
    margin: { top: 10, left: 110 },
    columnStyles: { 0: { halign: "center" } }, // Cells in first column centered and green
    head: [["Subtotal:", "Descuento:", "ITBIS:", "Total:"]],
    body: [
      [
        formatMonto(subtotal),
        formatMonto(data2.discount),
        formatMonto(itbis),
        characterData.codDivisa + "$" + " " + formatMonto(totales)
      ]
    ],
    theme: "grid",
    startY: docHeight - 77,
    tableWidth: 90
  });

  doc.line(20, docHeight - 40, docWidth - 130, docHeight - 40);

  doc.setFont("helvetica", "bold");
  doc.text("Elaborado por", 35, docHeight - 30);

  doc.line(130, docHeight - 40, docWidth - 20, docHeight - 40);

  doc.setFont("helvetica", "bold");
  doc.text("Recibido Conforme", 140, docHeight - 30);

  doc.setFontSize(9);
  doc.setFont("helvetica", "bold");
  doc.text("CUB SCOUT No. 41", 83, 280);
  doc.text("ENSACHE NACO", 85, 285);
  doc.text("RNC: 131844804 Tel.: 809-334-6037", 70, 290);

  if (donwload) {
    doc.save(`Cotización-del-cliente-${characterData.clientName}`);
    return;
  }
  frame.src = doc.output("bloburl");
};
export default generatePDF;
